<template>
  <span>
    <DaiCapaGeojsonPuntosDesplazados
      :id="idCapa"
      :datos="geojsonFiltrado"
      :distancia="140"
      :distanciaMinima="0"
      metodoDesplazamiento="anillos-concentricos"
      :radioPuntoCentro="radioPuntoCentro"
      :radioPuntosDesplazados="radioPuntosDesplazados"
      delimitarGruposPor="codigo_pais"
      :propsAsignaEstilo="['circle']"
      :fnAsignaEstilo="fnAsignaEstilo"
      :contenidoTooltip="contenidoTooltip"
      :zIndex="7"
      :zoomAlDarClick="false"
      @click_feature="click_feature"
    />
  </span>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from "vuex";
import GeojsonCache from "@/components/mapas/GeojsonCache";
import { ID_CAPA, obtenerFeatureExtent, idMexico } from "@/components/mapas/utiles";

const URL_REMOTE = "data/capas/siso_sargazo_actores-sargazo_nd_nd_mun_p.geojson";

export default {
  data: () => ({
    idCapa: ID_CAPA.galleta,
    capaActores: new GeojsonCache(URL_REMOTE),
    radioPuntoCentro: 2,
    radioPuntosDesplazados: 5,
  }),
  async mounted() {
    await this.capaActores.guardarGeojson();
  },
  methods: {
    ...mapMutations("mapaActores", ["cambiarExtensionMapa"]),
    ...mapActions("mapaActores", ["cambiarIdsUbicacionesPuntos", "cambiarCvesEdo"]),
    fnAsignaEstilo(f) {
      if (f["ring"]) {
        return [{ radius: f.ring.radius, stroke: { color: "gray" } }];
      }

      if (f["features"]) {
        if (f.features.length === 1) {
          return estiloPersona(f.features[0].getProperties(), this.radioPuntosDesplazados);
        }

        return [{ fill: { color: "black" }, radius: this.radioPuntoCentro }];
      }

      return estiloPersona(f, this.radioPuntosDesplazados);
    },
    contenidoTooltip(f) {
      if (f["features"]) {
        if (f.features.length === 1) {
          return tooltipPersona(f.features[0].getProperties());
        }

        const n = f.features.length;
        return `${n} persona${n !== 1 ? "s" : ""}`;
      }

      return tooltipPersona(f);
    },
    click_feature([f]) {
      // console.log(f);

      const features = f.get("features");
      if (features) {
        if (features.length === 1) {
          f = features[0];
        } else return;
        // this.cambiarIdsUbicacionesPuntos(features.map((f) => f.get("g_id")));
      }

      const anillo = f.get("ring");
      if (anillo) {
        // console.log("anillo", f);
        return;
      }

      // console.log(f.get("cve_ent"));
      this.cambiarCvesEdo(f.get("cve_ent"));
    },
    buscarExtentUnicoPunto(actor) {
      if (actor.codigo_pais === idMexico) {
        return obtenerFeatureExtent(
          this.$parent.cmpLayers[ID_CAPA.estados].olLayer,
          (f) => f.getProperties().cve_ent === actor.cve_ent
        );
      }

      return obtenerFeatureExtent(
        this.$parent.cmpLayers[ID_CAPA.paises].olLayer,
        (f) => f.getProperties().codigo === actor.codigo_pais
      );
    },
  },
  watch: {
    geojsonFiltrado(newVal) {
      const features = newVal.features;
      if (features.length > 1) {
        this.cambiarExtensionMapa(newVal.bbox);
      }

      if (features.length === 1) {
        this.cambiarExtensionMapa(this.buscarExtentUnicoPunto(features[0].properties));
      }
    },
  },
  computed: {
    ...mapGetters("mapaActores", ["actualRelacionActoresFiltrados"]),
    geojsonFiltrado() {
      return this.capaActores.status
        ? this.capaActores.geojsonFiltro(
            (f) => this.actualRelacionActoresFiltrados("g_id").includes(f.properties.g_id),
            true
          )
        : { type: "FeatureCollection", features: [] };
    },
  },
};

function estiloPersona(f, radio) {
  return [
    {
      fill: {
        color: require("@/components/mapas/utiles").coloresLineasEstrategicas[
          f.id_linea_estrategica
        ],
      },
      stroke: { color: "white", width: 1 },
      radius: radio,
    },
  ];
}

function tooltipPersona(f) {
  return (
    `<span class="tooltip-persona">` +
    (`<b>${f.nombre_actor}</b><br>` +
      `<b>Cargo: </b>${f.cargo_titulo}<br>` +
      `<b>Sector: </b>${f.sector}<br>` +
      `<b>Institución: </b>${f.institucion}<br>`) +
    `</span>`
  );
}
</script>

<style lang="scss">
.ol-tooltipmov .tooltip-persona {
  display: block;
  max-width: 250px;
  min-width: 250px;
  white-space: normal;
}
</style>
